import { Component } from '@angular/core';
import {  NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { TournamentService } from '../../../services/tournament.service';

@Component({
  selector: 'preround-edit-ko',
  templateUrl: 'preround-edit-ko.html',
})
export class ResultEditPreroundKoPage {

  activePlan: any;
  plan: any;
  ti: any;
  roundPhase: boolean = false;

  constructor(
    private navParams: NavParams,
    private toastCtrl: ToastController,
    private viewCtrl: ViewController,
    public gs: TournamentService,
    private navCtrl: NavController
    ) { 
      console.log(this.navCtrl.getViews());
    }

  ionViewDidLoad() {
    this.plan = this.navParams.get('plan');
    this.ti = this.navParams.get('teamIndex');
    this.roundPhase = this.navParams.get('roundPhase');
    this.activePlan = this.gs.planList.findIndex(x => x.id == this.plan.id);
    this.gs.save();
  }

  onChangeTeam(index){
    this.toastCtrl.create({
      duration: 5000,
      position: 'top',
    }).present();
  }


  onSave(){
    this.gs.save();
  }

  onResultChange(teamIndex: string, value: any){
    value = Number(value);
    if(value >= 0){
      let teamId =  this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j][teamIndex].id;
      let arrIndex = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === teamId);
      this.gs.planList[this.activePlan].teams[arrIndex].results =+ value;
      // let winner = this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].team1.results > this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].team2.results ? 0 : 1;
      // this.onSetWinner(winner);
    }
  }

  onPointsChange(teamIndex: string, value: any){
    value = Number(value);
    if(value >= 0){
      let teamId =  this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j][teamIndex].id;
      let arrIndex = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === teamId);
      this.gs.planList[this.activePlan].teams[arrIndex].points += value;      
      let winner = this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].team1.points > this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].team2.points ? 0 : 1;
      if(typeof this.gs.planList[this.activePlan].gameTable[this.ti.i + 1] != "undefined" && this.plan.roundPhase){
        let team = (this.ti.j % 2) ? 'team2' : 'team1';
        this.gs.planList[this.activePlan].gameTable[this.ti.i + 1][Math.floor(this.ti.j / 2)][team].id = this.gs.planList[this.activePlan].teams[arrIndex].id;
        this.gs.planList[this.activePlan].gameTable[this.ti.i + 1][Math.floor(this.ti.j / 2)][team].name = this.gs.planList[this.activePlan].teams[arrIndex].name;
      }
      this.onSetWinner(winner);
      // this.checkCompletion();
    }
  }

  teamClick(winnerIndex: number){
    this.onSetWinner(winnerIndex);
    // this.checkCompletion();
  }

  onSetWinner(winnerIndex: number){
    this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].played = true;
    this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].winner = winnerIndex;
    this.gs.save();
  }
  
  checkCompletion(){
    for(let i = 0; i < this.gs.planList[this.activePlan].gameTable.length; i++){
      for(let j = 0; j < this.gs.planList[this.activePlan].gameTable[i].length; j++){
          this.gs.planList[this.activePlan].roundPhase = this.gs.planList[this.activePlan].gameTable[i][j].played;
      }
    }
  }

  onClose(){
    this.viewCtrl.dismiss();
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/edits/pre-round-ko/preround-edit-ko.ts